<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fmh"><a id="page_vii"></a><span class="bold">Author’s Note</span></h2>
<p class="noindent">Unless otherwise specified in the Notes, all quotes and extracts have been taken from files at the National Archives at Kew (TNA). When quoting from these files some minor formatting changes have occasionally been made to ensure the text flows better, and accents added to French and German words where they were missed out in the original text because the typewriters of the time lacked those keys; otherwise, no changes have been made to the original punctuation or spelling. The terms ‘MI6’ and ‘SIS’ are frequently used interchangeably to mean the British Secret Intelligence Service. Unless it is specifically used in a quote or a bibliographic reference, the term ‘SIS’ will be used in this book. Codenames or aliases are prefixed using the symbol @. Some names have been redacted from the original documents, but where possible these have been identified and inserted in square brackets, thus: [John Smith].</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Author.vue?7c8374d9